module.exports = __webpack_public_path__ + "static/media/Lexington-Green-Covenants.06f4c049.pdf";